import React, { useState } from "react";
import PropTypes from "prop-types";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { secretCodeFormatter } from "../../lib/secret-code-formatter";

const SecretCodeInfo = ({ secretCode }) => {
  return (
    <ul className="list-disc px-6 text-sm text-gray-600 space-y-2">
      <li>
        Open your authenticator app and tap <strong>Add New Account</strong>
        or the &apos;+&apos; icon.
      </li>
      <li>
        Tap <strong> Scan code manually</strong>. In some apps, you&apos;ll need to tap Scan
        QR code first before being given this option.
      </li>
      <li>
        Enter the following key: <strong>{secretCodeFormatter(secretCode)}</strong>
      </li>
      <li>
        When searching for a logo, type &apos;Breathe HR&apos; and click
        <strong> Search</strong>. Then select the Breathe HR logo that appears.
      </li>
      <li>
        In &apos;Account nickname&apos; type &apos;Breathe HR&apos; and click
        <strong> Save</strong>.
      </li>
    </ul>
  );
};

export const SecretCodeRenderer = ({ secretCode }) => {
  const [showSecretCode, setShowSecretCode] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    setShowSecretCode(!showSecretCode);
  };

  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="flex items-center justify-center w-full">
        <button
          type="button"
          onClick={handleClick}
          className="text-sm font-semibold rounded-md px-4 py-2 h-9 flex items-center justify-center gap-2 transition-colors"
          style={{ 
            backgroundColor: "#f5f5f5",
            color: "#171717",
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#e5e5e5"; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#f5f5f5"; }}
        >
          <FontAwesomeIcon icon={faQuestionCircle} className="w-4 h-4" />
          Can&apos;t scan the QR code?
        </button>
      </div>
      
      {showSecretCode && (
        <div className="w-full">
          <SecretCodeInfo secretCode={secretCode} />
        </div>
      )}
    </div>
  );
};

SecretCodeRenderer.propTypes = {
  secretCode: PropTypes.string,
};
SecretCodeRenderer.defaultProps = {
  secretCode: "",
};

SecretCodeInfo.propTypes = {
  secretCode: PropTypes.string,
};
SecretCodeInfo.defaultProps = {
  secretCode: "",
};
